










































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '@/CommonFeature/components/ApiAccessBase.vue';
import router from '@/router';
// 定数ファイル
import { CustomScreenName } from '../fixed/CustomScreenName';
// 共通モジュール
import { supervisingModule } from '@/store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { traderInfoModule } from '../store/modules/TraderInfo';
import { ITraderKey } from '../store/dto/TraderInfo';
import { Constants } from '@/CommonUtils/fixed/Constants';
import { CustomConstants } from '../fixed/CustomConstants';
import { Message } from '@/CommonUtils/fixed/Message'; // メッセージ
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class TraderInfoKanri extends ApiAccessBase {
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [{}];

  private created() {
    this.screenTitle = 'CE財団連携データ管理';
    this.screenRemarks = '受付データ退避：基準日時点で最新のデータを取得し、受付反映予定データとして管理します。画面を閉じても処理は実行され、開き直した際に実行結果一覧が更新されます。';
    // getInit呼び出し
    this.apiAccess(CustomConstants.TRADER_INFO_KANRI_INIT_PATH, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          this.setAllVariablecolsState();
          //検索結果.ボタンの設定
          this.headers.shift(); //先頭の空白列削除
          //検索結果.DBから展開
          for (const item of this.variablecols['trader_info_kanri_log'] ) {
            this.headers.push({text: item.label,
                              align: item.align,
                              sortable: item.sortable,
                              value: item.name,
                              width: item.width,
                              } );
          }
          //受付データ退避ログ取得
          this.apiAccess(CustomConstants.TRADER_INFO_KANRI_INIT_SEARCH_PATH, Constants.API_METHOD_POST, true, true);
        }
      },
    );
  }

  private taihi() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // this.moldingSendForm(this.$refs.form);
    // ボタン押下時
    if (window.confirm(Message.I0031)) {
      // 受付データ退避
      this.apiAccess(CustomConstants.TRADER_INFO_KANRI_PATH, Constants.API_METHOD_POST, true, true).then(
          (result) => {
            if ((result) === Constants.API_RESULT_SUCCES) {
              // //再検索前に登録成功メッセージ保持
              // const successMessage = this.infoMessage;
              // //受付データ退避ログ再検索
              // this.apiAccess(CustomConstants.TRADER_INFO_KANRI_INIT_SEARCH_PATH, Constants.API_METHOD_POST, true, true);
              // alert('test');
              // //再検索後に登録成功メッセージ格納
              // this.infoMessage = successMessage;
            }
          },
      );
    }
  }

  private clear() {
    // ボタン押下時
    if (window.confirm(Message.I0032)) {
      // 受付データ退避
      this.apiAccess(CustomConstants.TRADER_INFO_KANRI_DELETE_PATH, Constants.API_METHOD_POST, true, true).then(
          (result) => {
            if ((result) === Constants.API_RESULT_SUCCES) {
            }
          },
      );
    }
  }

  private returnPrevious() {
    router.push({name: CustomScreenName.CE_MENU});
  }

}
